export const PollsView = () => {
    return(
        <p>Example</p>
    )
}